import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      const val = params[key];
      if (val !== undefined && val !== null && val !== "") {
        queryParams.append(key, val.toString());
      }
    });
  }
  const query = queryParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

function getExpeditions(params: {
  limit: number;
  skip: number;
  keyword?: string;
  owner?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
}) {
  const baseUrl = "expeditions";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching expeditions:", error);
  }
}

function createExpeditionApi(params: {
  country: string;
  comment: string;
  description: string;
  expeditionDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}) {
  const baseUrl = "expeditions";
  const url = buildUrl(baseUrl);

  try {
    return getApiInstance().post(url, params);
  } catch (error) {
    console.error("Error creating expedition:", error);
  }
}

function deleteExpeditionApi(params: { ids: string[] }) {
  const baseUrl = "expeditions";
  const url = `${baseUrl}/delete`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error Deletting expedition:", error);
  }
}

function updateExpeditionApi(params: {
  id: string;
  comment: string;
  description: string;
  expeditionDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
  damaged: number;
}) {
  const baseUrl = "expeditions";
  const url = `${baseUrl}/${params.id}`;
  try {
    return API.put(url, params);
  } catch (error) {
    console.error("Error updating expedition:", error);
  }
}

function updateStatusExpeditionApi(params: { id: string }) {
  const baseUrl = "expeditions";
  const url = `${baseUrl}/status/${params.id}`;
  try {
    return API.put(url, params);
  } catch (error) {
    console.error("Error updating status expedition:", error);
  }
}

function getExpedition(params: { id: string }) {
  const baseUrl = "expeditions";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching expedition:", error);
  }
}

export {
  getExpeditions,
  createExpeditionApi,
  getExpedition,
  updateExpeditionApi,
  updateStatusExpeditionApi,
  deleteExpeditionApi,
};
